'use client';

import { c as _c } from "react/compiler-runtime";
import { type ComponentProps, useMemo } from 'react';
import { SEARCH_PAGE_PARAM_KEY } from '@module/mdrt-org/shared/utils/constants/learn-search-constants';
import { Pagination } from '@shared/ui-components/pagination/pagination';
import { usePageScroll } from '@shared/utils/hooks/use-page-scroll';
import { type SearchCmsContent } from '../../graphql/get-search-cms-content';
import { type SearchPageSearchParameters } from '../../types';
import styles from './search-pagination.module.scss';
type SearchPaginationProps = {
  genericCmsContent: SearchCmsContent['generic'];
  onPageChange: (searchParameters: SearchPageSearchParameters) => void;
  pageIndex: number;
  totalCount: number;
};
export const SearchPagination = t0 => {
  const $ = _c(12);
  const {
    genericCmsContent,
    onPageChange,
    pageIndex,
    totalCount
  } = t0;
  const page = pageIndex + 1;
  usePageScroll(page);
  let t1;
  if ($[0] !== onPageChange) {
    t1 = nextPage => {
      const nextPageIndex = nextPage - 1;
      const parameterValue = nextPageIndex > 0 ? nextPageIndex.toString() : "";
      onPageChange({
        [SEARCH_PAGE_PARAM_KEY]: parameterValue
      });
    };
    $[0] = onPageChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handlePageChange = t1;
  let t2;
  if ($[2] !== genericCmsContent.nextPageLabel || $[3] !== genericCmsContent.pagination || $[4] !== genericCmsContent.previousPageLabel || $[5] !== genericCmsContent.totalItemsCountLabel) {
    t2 = {
      nextPage: genericCmsContent.nextPageLabel,
      pagination: genericCmsContent.pagination,
      previousPage: genericCmsContent.previousPageLabel,
      totalItemsCount: genericCmsContent.totalItemsCountLabel
    };
    $[2] = genericCmsContent.nextPageLabel;
    $[3] = genericCmsContent.pagination;
    $[4] = genericCmsContent.previousPageLabel;
    $[5] = genericCmsContent.totalItemsCountLabel;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const labelMap = t2;
  let t3;
  if ($[7] !== handlePageChange || $[8] !== labelMap || $[9] !== page || $[10] !== totalCount) {
    t3 = <Pagination blurButtonsOnPageChange={true} className={styles["search-pagination"]} currentPage={page} label={labelMap} onPageChange={handlePageChange} totalItemsCount={totalCount} />;
    $[7] = handlePageChange;
    $[8] = labelMap;
    $[9] = page;
    $[10] = totalCount;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};